// extracted by mini-css-extract-plugin
module.exports = {"authBackground":"LoadingPage_authBackground__DOrH1","animatedBackground":"LoadingPage_animatedBackground__1pwf0","loadingBackground":"LoadingPage_loadingBackground__3e6Cn"};